import { useCallback, memo } from "react";

import { useDeviceType } from "@/common/hooks";
import { deviceTypeEnum } from "@/common/utils/device";

import { links } from "../config/liveButton";

import live1 from "./images/live-1.webp";
import live2 from "./images/live-2.webp";
import live3 from "./images/live-3.webp";
import classes from "./LiveButton.module.scss";

const liveImages = [live1, live2, live3];

const LiveButton = memo(() => {
  const isDesktop = useDeviceType() === deviceTypeEnum.DESKTOP;

  const handleClick = useCallback(() => {
    window.location.href = isDesktop ? links.desktop : links.mobile;
  }, [isDesktop]);

  const liveImage = liveImages[Math.floor(Math.random() * liveImages.length)];

  return (
    <div className={classes.liveAdButton} onClick={handleClick}>
      <div className={classes.flash}></div>
      <div className={classes.imageWrapper}>
        <img className={classes.image} loading="lazy" src={liveImage} width={26} height={26} alt="Live site" />
      </div>
      <div className={classes.textWrapper}>
        <span className={classes.text}>LIVE</span>
      </div>
    </div>
  );
});

export default LiveButton;
